import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const defaultProps = {
  checked: false,
};

const propTypes = {
  checked: PropTypes.bool,
};

function TrainerInfoCheck({ checked, innerRef }) {
  return (
    <div
      className={clsx(
        'cursor-pointer w-6 h-6 rounded-full flex items-center justify-center',
        {
          'bg-green-100 hover:bg-green-200 text-green-700': checked === true,
          'bg-red-100 hover:bg-red-200 text-red-700': checked === false,
        }
      )}
      ref={innerRef}
    >
      <svg
        className="w-4 h-4"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fillRule="evenodd"
          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
          clipRule="evenodd"
        />
      </svg>
    </div>
  );
}

TrainerInfoCheck.defaultProps = defaultProps;
TrainerInfoCheck.propTypes = propTypes;

export default forwardRef((props, ref) => (
  <TrainerInfoCheck {...props} innerRef={ref} />
));
